import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { DelonACLModule } from '@delon/acl';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { EInvoiceUuidModalComponent } from '../uuid-modal/uuid-modal.component';

@Component({
  selector: 'app-einv-status',
  templateUrl: './einv-status.component.html',
  styles: [],
  standalone: true,
  imports: [
    CommonModule,
    NzTagModule,
    DelonACLModule,
    EInvoiceUuidModalComponent,
    NzToolTipModule
  ]
})
export class EinvoiceStatusComponent {
  @Input() value: any;
  @Output() readonly statusChange = new EventEmitter<string>();
  @Output() readonly statusCancelled = new EventEmitter<void>();
  @Input() uuid: string = '';
  @Input() isConsolidated: boolean = false;
  
  @ViewChild('uuidModal') uuidModal!: EInvoiceUuidModalComponent;

  openUuidModal() {
    this.uuidModal.showLhdnDocument(this.uuid);
  }

  onStatusChange(newStatus: string) {
    this.value = newStatus;
    this.statusChange.emit(newStatus);

    // Emit cancelled event when status changes to Cancelled
    if (newStatus === 'Cancelled') {
      this.statusCancelled.emit();
    }
  }

  // Computed property for display value
  get displayValue(): string {
    const prefix = 'LHDN: ';

    if (!this.value) 
      return `${prefix}Pending`;
    
    const suffix = this.isConsolidated ? ' - Consolidated' : '';
    return `${prefix}${this.value}${suffix}`;
  }

  // Computed property for tag color
  get tagColor(): string {
    switch (this.value) {
      case 'Valid': return 'success';
      case 'Invalid': return 'error';
      case 'Rejected': return 'magenta';
      case 'Cancelled': return 'error';
      default: return 'default';
    }
  }

  // Method to get tooltip title
  getTooltipTitle(): string {
    switch (this.value) {
      case 'Valid': return 'Document has been validated successfully';
      case 'Invalid': return 'Document validation failed';
      case 'Rejected': return 'Document has been rejected by LHDNM';
      case 'Cancelled': return 'Document has been cancelled by LHDNM';
      default: return 'Document status is pending';
    }
  }

  // Check if should show success icon
  get showSuccessIcon(): boolean {
    return this.value === 'Valid';
  }
}
